import { useAppDispatch } from 'app/store';
import { useEffect } from 'react';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { ReportPromoWidget } from 'widgets/ReportPromo/ui';

export const ReportPromoPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Отчет по акциям'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, [dispatch]);

  return <ReportPromoWidget />;
};
